module.exports = __webpack_public_path__ + "img/B559.73cabc41.jpg";